import React from "react";
import Button from "@mui/material/Button";

function Policy({ t }) {
  React.useEffect(() => {
    document.title = "Exchange or Return Policy";
  }, []);

  // const [value, setValue] = React.seState("");

  // const onPaste = (e) => {
  //   const paste = e.clipboardData.getData("text/plain");
  //   if (paste.match(/[-\.]/)) return;
  //   setValue(paste);
  // };

  // const handleChange = (e) => {
  //   e.preventDefault();
  // };

  return (
    <div
      style={{
        fontFamily: '"Helvetica Neue" ,Helvetica, Arial, "sans-serif"',
        padding: "2em",
        // pointerEvents: false,
        // opacity: 0.7,
        WebkitUserSelect: "none",
        MozUserSelect: "none",
        MsUserSelect: "none",
        UserSelect: "none",
      }}
    >
      {/* <input value={value} onPaste={onPaste} />
      {value} */}
      <strong>سياسة الاستبدال أو الاسترجاع</strong>{" "}
      <p>
        ملاحظة: جميع حالات الاستبدال أو الاسترجاع تطبق حصراً في حال كانت البضاعة
        في حالتها الأصلية وغير معدلة أو مستخدمة. إذا كنت غير راض عن البضاعة
        المستلمة وترغب باستبدالها أو استرجاع قيمتها وذلك لوجود عيب حدث للمنتج
        خلال عملية الشحن أو وصلك منتج مختلف عن طلب أو وجود خطأ مصنعي ، فكل ما
        عليك القيام به هو التواصل معنا عبر{" "}
        <Button
          onClick={() => window.open(`mailto:useaterapp@gmail.com`)}
          variant="text"
          color="inherit"
          size="small"

          // className={classes.button}
        >
          {/* {t("contactUs")} */}
          useaterapp@gmail.com
        </Button>{" "}
        سنقوم بخدمتك على أكمل وجه
      </p>{" "}
      <p>
        في حال رغبتك في إستبدال الطلب أو جزء منه: يسعدنا خدمتك من خلال تواصلك
        معنا عبر{" "}
        <Button
          onClick={() => window.open(`mailto:useaterapp@gmail.com`)}
          variant="text"
          color="inherit"
          size="small"

          // className={classes.button}
        >
          {/* {t("contactUs")} */}
          useaterapp@gmail.com
        </Button>{" "}
        وتسجيل طلب الاستبدال خلال مدة أقصاها 7 أيام من تاريخ استلام طلبيتك،
        وإخبارهم بالمنتجات التي ترغب في إستبدالها والمنتجات الجديدة التي تود
        الحصول عليها وسيقوم موظفونا بخدمتك على أكمل وجه. حيث سيتم توجيهك لاقرب
        فرع شركة شحن لتسليم البضاعة التي تود استبدالها. وبعد وصول البضاعة إلينا
        والموافقة على طلب الاستبدال سيقوم موظفونا بالتواصل معك و تحديد البضاعة
        الجديدة و شحنها لك. ملاحظة: الرجاء الاحتفاظ بوصل تسليم البضاعة مع رقم
        بوليصة الشحن مع الاخذ بعين الاعتبار أن قيمة عملية شحن البضاعة المستبدلة
        والجديدة ستكون على حساب العميل.
      </p>{" "}
      <p>
        في حال رغبتك في إسترجاع الطلب أو جزء منه: يسعدنا خدمتك من خلال تواصلك
        معنا عبر{" "}
        <Button
          onClick={() => window.open(`mailto:useaterapp@gmail.com`)}
          variant="text"
          color="inherit"
          size="small"

          // className={classes.button}
        >
          {/* {t("contactUs")} */}
          useaterapp@gmail.com
        </Button>{" "}
        من اجل تسجيل طلب الاسترجاع خلال مدة أقصاها 7 أيام من تاريخ استلام
        طلبيتك، وإخبارهم بالمنتجات التي ترغب في ارجاعها و استرداد قيمتها وسيقوم
        موظفونا بخدمتك على أكمل وجه. حيث سيتم توجيهك لاقرب فرع شركة شحن لتسليم
        البضاعة المسترجعة. وبعد وصول البضاعة والموافقة على طلب الاسترجاع سيقوم
        موظفونا بالتواصل معك و تحديد طريقة استلام قيمة البضاعة المسترجعة ملاحظة:
        الرجاء الاحتفاظ بوصل تسليم البضاعة مع رقم بوليصة الشحن مع الاخذ بعين
        الاعتبار أن قيمة عملية شحن البضاعة المستبدلة والجديدة ستكون على حساب
        العميل.
      </p>{" "}
      <p>
        • فورالموافقة على طلب الاسترجاع يمكنك استرداد قيمة البضاعة المسترجعة اما
        عبر كوبون بنفس قيمة البضاعة المسترجعة يمكنك استخدامه للشراء من تطبيق
        (عطر) في اي وقت صالح لمدة سنة مع هدية مجانية. كما يمكنك استرداد قيمة
        البضاعة المسترجعة نقداً من خلال تحويل بنكي وذلك بعد تزودينا برقم حسابك
        لتحويل قيمة البضائع إلي حسابك نقداً.
      </p>
    </div>
  );
}

export default Policy;
